export const lcfirst = (str) => {
    return str ? str[0].toLowerCase() + str.substring(1) : '';
};
